import $ from "jquery";

import gsap, { Power4 } from "gsap";
import ScrollToPlugin from "gsap/dist/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

const postsPagination = () => {
  const postsContainer = document.querySelector(".js-posts-container");
  if (!postsContainer) return;
  let selctedCategory = "";
  history.scrollRestoration = "manual";
  let scrolling = false;
  let newData;
  let loading = 0;

  const skeletons = document.querySelector(".js-posts-box-skeletons");
  const postsBox = document.querySelector(".js-posts-box");
  const postsPaginationBox = document.querySelector(".js-posts-pagination");
  const title = document.querySelector(".js-category-title");
  const paragraph = document.querySelector(".js-category-paragraph");

  let baseURl = document.querySelector(".site").getAttribute("data-url");

  const baseURlCleared = baseURl.replace("/en/", "/");

  const categoryLinks = [...document.querySelectorAll(".js-posts-category-tab")];
  categoryLinks.forEach((tab) => {
    if (tab.classList.contains("active")) {
      selctedCategory = tab.getAttribute("data-slug");
    }
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      selctedCategory = tab.getAttribute("data-slug");
      categoryLinks.forEach((link) => {
        link.classList.remove("active");
      });
      tab.classList.add("active");
      handleAjaxCall(tab.getAttribute("href"), tab.getAttribute("data-slug"), 1);
    });
  });

  const initPostLinks = () => {
    const categoryPostLinks = [...document.querySelectorAll(".js-post-category")];
    categoryPostLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        categoryLinks.forEach((l) => {
          if (l.getAttribute("data-slug") === link.getAttribute("data-slug")) {
            l.classList.add("active");
          } else {
            l.classList.remove("active");
          }
        });
        selctedCategory = link.getAttribute("data-slug");
        handleAjaxCall(link.getAttribute("href"), link.getAttribute("data-slug"), 1);
      });
    });
  };
  initPostLinks();

  const initPaginationLinks = () => {
    const paginationLinks = postsPaginationBox.querySelectorAll("a");
    paginationLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        handleAjaxCall(link.getAttribute("href"), selctedCategory, link.getAttribute("data-page"));
      });
    });
  };

  initPaginationLinks();

  const handleAjaxCall = (url, slug, page) => {
    skeletons.classList.add("show");
    postsBox.classList.add("hide");
    loading++;
    window.history.pushState({}, "", decodeURIComponent(url));

    gsap.to(window, {
      duration: 0.5,
      scrollTo: {
        y: postsContainer,
        offsetY: document.querySelector(".js-header").getBoundingClientRect().height,
      },
      onStart: () => {
        scrolling = true;
      },
      onComplete: () => {
        scrolling = false;
        if (newData) {
          postsBox.innerHTML = newData;
          skeletons.classList.remove("show");
          postsBox.classList.remove("hide");
          if (postsBox.querySelector(".js-category-title-ajax")) {
            title.innerHTML = postsBox.querySelector(".js-category-title-ajax").innerHTML;
          }
          if (postsBox.querySelector(".js-category-paragraph-ajax")) {
            paragraph.innerHTML = postsBox.querySelector(".js-category-paragraph-ajax").innerHTML;
          }
          if (!document.querySelector(".posts-pagination-inner")) return;
          postsPaginationBox.innerHTML = "";
          if (postsBox.querySelector(".posts-pagination-inner")) {
            postsPaginationBox.insertAdjacentElement("beforeend", postsBox.querySelector(".posts-pagination-inner"));
          }
          initPaginationLinks();
          initPostLinks();
        }
      },

      ease: Power4.easeInOut,
    });

    $.ajax({
      type: "POST",
      dataType: "html",
      url: `${baseURlCleared}wp-admin/admin-ajax.php`,
      data: {
        action: "posts_ajax_load",
        category: slug,
        page: page,
      },
      success: function (data) {
        loading--;
        if (loading != 0) return;
        if (scrolling) {
          newData = data;
        } else {
          newData = "";
          postsBox.innerHTML = data;
          skeletons.classList.remove("show");
          postsBox.classList.remove("hide");
          title.innerHTML = postsBox.querySelector(".js-category-title-ajax").innerHTML;
          paragraph.innerHTML = postsBox.querySelector(".js-category-paragraph-ajax").innerHTML;
          if (!document.querySelector(".posts-pagination-inner")) return;
          postsPaginationBox.innerHTML = "";
          if (postsBox.querySelector(".posts-pagination-inner")) {
            postsPaginationBox.insertAdjacentElement("beforeend", postsBox.querySelector(".posts-pagination-inner"));
          }
          initPaginationLinks();
          initPostLinks();
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log("error");
      },
    });
  };

  window.addEventListener(
    "popstate",
    (e) => {
      location.href = e.currentTarget.location.href;
    },
    false
  );
};

export default postsPagination;
